import { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import externalPageApi from "api/externalPage";

const useConfirmRequestPayment = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const { search } = useLocation();
  const { token } = useParams();
  const isAgency = new URLSearchParams(search).get("agency");
  const poNumber = new URLSearchParams(search).get("poNumber");

  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        isAgency: isAgency === "true" ? true : false,
        token,
        invoiceKey: isAgency ? data.invoice : null,
      };

      await externalPageApi.respondRequestPayment(payload);
      setSuccessMsg(t("requestPaymentSuccessMsg"));
    } catch (err) {
      console.error(err);
      notifyError(
        err?.response?.data?.message ?? err?.message ?? "Something went wrong!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { onSubmit, navigate, isLoading, isAgency, successMsg, poNumber };
};

export default useConfirmRequestPayment;
